import { Controller } from '@hotwired/stimulus';

/** Scroll reveals for JTBD homepage; respects prefers-reduced-motion */
export default class extends Controller {
  connect() {
    this.prefersReduced =
      typeof window.matchMedia === 'function' &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    this.items = Array.from(this.element.querySelectorAll('.bs-jtbd-reveal'));

    if (this.prefersReduced) {
      this.items.forEach((el) => {
        el.classList.remove('bs-jtbd-reveal--pending');
        el.classList.add('bs-jtbd-reveal--visible');
      });
      return;
    }

    this.items.forEach((el) => el.classList.add('bs-jtbd-reveal--pending'));

    this.observer = new IntersectionObserver(this.onIntersect.bind(this), {
      rootMargin: '0px 0px -10% 0px',
      threshold: 0.08,
    });
    this.items.forEach((el) => this.observer.observe(el));
  }

  disconnect() {
    if (this.observer) this.observer.disconnect();
  }

  onIntersect(entries) {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      const el = entry.target;
      el.classList.remove('bs-jtbd-reveal--pending');
      el.classList.add('bs-jtbd-reveal--visible');
      this.observer.unobserve(el);
    });
  }
}
